const _timestampWithMilliseconds = () => {
  const date = new Date()
  return date.getTime()
}
const _searchMode = (showFilterRow, storageKey) => {
  let currentSearchByColumnsMode = localStorage.getItem(storageKey)
  if (currentSearchByColumnsMode === 'false' || currentSearchByColumnsMode === null) {
    currentSearchByColumnsMode = showFilterRow
  } else {
    currentSearchByColumnsMode = true
  }
  localStorage.setItem(storageKey, currentSearchByColumnsMode)
  return currentSearchByColumnsMode
}

// const _storageKey = (storageKey, title) => {
//   title = false
//   if (!title) {
//     title = `mfGridNOTITLE.${_timestampWithMilliseconds}`
//   }
//   let thisStorageKey = storageKey
//   if (!storageKey) {
//     // thisStorageKey = `mfGrid${title.replace(/\s+/g, '')}.${_timestampWithMilliseconds}`
//     thisStorageKey = `mfGrid${title.replace(/\s+/g, '')}`
//   }
//   const storageKeyPrefix = storageKey ? storageKey.split('.')[0] : 'mfGrid'
//   for (let key in localStorage) {
//     if (key.startsWith(storageKeyPrefix) ) {
//       localStorage.removeItem(key);
//     }
//   }
//   localStorage.removeItem(storageKeyPrefix)
//   return thisStorageKey
// }

export { _searchMode, _timestampWithMilliseconds }
